import React, { ChangeEvent, SyntheticEvent, useEffect, useState } from "react";
import { connect } from "react-redux";
import { useNavigate } from "react-router-dom";
import { CreateUserFormError, CreateUserProps } from "../../store/actionType";
import { createUserValidator } from "utils/helpers/CreateUserHelper";
import {
  saveCreateUserFormData,
  updateCreateUserFormErrorState,
  checkForExistingUserByMobile,
  checkForExistingUserByEmail,
  createUser,
  resetState,
} from "../../store/action";
import CreateUserForm from "./components/CreateUserForm";

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type StateProps = ReturnType<typeof mapStateToProps>;
type OwnProps = {
  closeModal: React.Dispatch<React.SetStateAction<boolean>>;
};
type Props = DispatchProps & StateProps & OwnProps;

const HandleUserCreate: React.FC<Props> = ({
  onCreateUser,
  onUpdateCreateUserFormError,
  createUserFormData,
  createUserFormError,
  onCheckForExistingUserByMobile,
  onCheckForExistingUserByEmail,
  closeModal,
  onResetUserData
}) => {
  const [formData, setFormData] = useState<CreateUserProps>({
    ...createUserFormData,
  });
  const [showpassword, setShowpassword] = useState<boolean>(false);

  const [errors, setErrors] = useState<CreateUserFormError>({
    ...createUserFormError,
  });

  const [loading, setLoading] = useState<boolean>(false);

  const [formSubmitted, setFormSubmitted] = useState<boolean>(false); // NEW FLAG

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
    setErrors((prevErrors: CreateUserFormError) => ({
      ...prevErrors,
      [name]: undefined,
    }));
  };

  const resetForm = () => {
    setFormData({
      ...createUserFormData,
    });
    setErrors({
      ...createUserFormError,
    });
    setFormSubmitted(false);
    setLoading(false);
  };

  const handleSaveFormData = async (e: SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault();
    setLoading(true);
    setFormSubmitted(true);

    const formErrors = createUserValidator(formData);
    setErrors(formErrors);
    onUpdateCreateUserFormError(formErrors);
    const hasErrors = Object.values(formErrors).some((error) => error !== null);
    if (hasErrors) {
      setLoading(false);
      setFormSubmitted(false);
      setFormSubmitted(false);
      return;
    }
    if (formData.email) {
      await onCheckForExistingUserByEmail(formData.email);
    }
    if (formData.mobile_no) {
      await onCheckForExistingUserByMobile(formData.mobile_no);
    }
    closeModal(false);
  };

  const createUser = async () => {
    await onCreateUser(formData);
    resetForm();
  };

  useEffect(() => {
    onResetUserData()
    if (
      formSubmitted &&
      Object.values(createUserFormError).every((error) => error === null)
    ) {
      createUser();
      setFormSubmitted(false);
    }
    setLoading(false);
  }, [createUserFormError, formSubmitted]);

  return (
    <>
      <CreateUserForm
        header="Create User"
        formData={formData}
        loading={loading}
        handleChange={handleChange}
        handleSave={handleSaveFormData}
        error={errors}
      />
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onSaveCreateUserFormData: (data: CreateUserProps) =>
    dispatch(saveCreateUserFormData(data)),
  onUpdateCreateUserFormError: (data: CreateUserFormError) =>
    dispatch(updateCreateUserFormErrorState(data)),
  onCheckForExistingUserByMobile: (data: string) =>
    dispatch(checkForExistingUserByMobile(data)),
  onCheckForExistingUserByEmail: (data: string) =>
    dispatch(checkForExistingUserByEmail(data)),
  onCreateUser: (user_input: CreateUserProps) =>
    dispatch(createUser(user_input)),
  onResetUserData: () => dispatch(resetState)
});

const mapStateToProps = (state: any) => ({
  createUserFormData: state.users.createUserFormData,
  createUserFormError: state.users.createUserFormError,
  checkForExistingUserByEmailState:
    state.users.checkForExistingUserByEmail,
  checkForExistingUserByMobileState:
    state.users.checkForExistingUserByMobile,
});

export default connect(mapStateToProps, mapDispatchToProps)(HandleUserCreate);
